import { photos } from "../utils/images";

export const galleryCategories = ["All", "Rooms", "Events", "Dining", "Exterior"];

export const gallery = [
  { id: 1, src: photos.hero, cat: "Exterior", alt: "Hotel building at dusk" },
  { id: 2, src: photos.roomKing, cat: "Rooms", alt: "King room with soft lighting" },
  { id: 3, src: photos.hall, cat: "Events", alt: "Banquet hall set for a reception" },
  { id: 4, src: photos.dining, cat: "Dining", alt: "Restaurant table setting" },
  { id: 5, src: photos.roomSuite, cat: "Rooms", alt: "Suite bedroom" },
  { id: 6, src: photos.lobby, cat: "Events", alt: "Wedding décor" },
  { id: 7, src: photos.exterior, cat: "Exterior", alt: "Hotel façade" },
  { id: 8, src: photos.roomTriple, cat: "Rooms", alt: "Triple room beds" },
  { id: 9, src: photos.conference, cat: "Events", alt: "Conference seating" },
  { id: 10, src: photos.dining2, cat: "Dining", alt: "Dining interior" },
  { id: 11, src: photos.bath, cat: "Rooms", alt: "Clean private bathroom" },
  { id: 12, src: photos.exterior2, cat: "Exterior", alt: "Hotel entrance" },
  { id: 13, src: photos.lobby, cat: "Rooms", alt: "Lounge and living area" },
  { id: 14, src: photos.pool, cat: "Exterior", alt: "Resort-style outdoor space" },
];
